import UgcVideoCarouselComponent from '../../../slices/UgcVideoCarousel'

interface Props {
	slice: any
}

export default function UgcVideoCarousel({ slice }: Props) {
	const { primary, items } = slice

	const videos = (items || [])
		.map((item: any) => {
			const videoUrl = item.video_url?.url
			if (!videoUrl) return null
			return {
				videoUrl,
				thumbnailUrl: item.thumbnail_image?.url || '',
				thumbnailAlt: item.thumbnail_image?.alt || '',
				overlayText: item.overlay_text || ''
			}
		})
		.filter(Boolean)

	return (
		<UgcVideoCarouselComponent
			sliceType={slice.slice_type}
			sliceVariation={slice.variation}
			title={primary?.section_title}
			description={primary?.section_description}
			ctaLabel={primary?.cta_label}
			ctaLink={primary?.cta_link}
			backgroundColor={primary?.background_color || '#FFFFFF'}
			videos={videos}
		/>
	)
}
